export const enToHePopulation = {
    "elderly": "קשישים",
    "childrenYouth": "ילדים ונוער",
    "specialPopulations": "אוכלוסיות מיוחדות",
    "other": "אחר",
    "animals": "בעלי חיים",
    "environment": "איכות הסביבה",
};
